"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLS = void 0;
exports.URLS = {
    practice_guide: (customerCode, practiceGroupId) => `/api/searchservice-v8/${customerCode}/practice_groups/${practiceGroupId}`,
    scope_of_practice: (customerCode, providerId) => `/api/searchservice-v8/${customerCode}/scope-of-practice/${providerId}?fields=-ALL,scope_of_practice`,
    clinical_keywords: (customerCode, providerId) => `/api/searchservice-v9/${customerCode}/providers/${providerId}?provider_fields=clinical_keywords&availability_fields=-ALL&location_fields=-ALL`
};
//# sourceMappingURL=urls.js.map